import * as React from 'react';
import { connect } from 'react-redux';

import { GlobalPrivateState, QueryParameterState, getCountryNameByCode } from 'src/api';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';
import classNames from 'classnames';
import { Icon } from '../../Images';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import PricingsPeriodModal from './PricingsPeriodModal';
import { Link } from 'react-router-dom'; // Hmm
import PricingsMarketModal from './PricingsMarket';
import './../UserList/UserList.scss';
import './Pricing.scss';
import { Modal } from 'reactstrap';
import { PricingsModel } from 'franke-trough-dependencies';
 
export interface PricingsProps {
  pricings: GlobalPrivateState['pricings'];
  params: QueryParameterState['params'];
  dispatch: any;
}

export interface PricingsState {
  isAddingPeriod: boolean;
  isEditingPeriod: boolean;
  isAddingMarket: boolean;
  isEditingMarket: boolean;
  isDeletingMarket: boolean;
  isPausingMarket: boolean;
  addingType?: string;
  pricings: any;
  selectedPricing?: PricingsModel;
}

export const formatPeriod = (from: string, until: string) => {
  const dateFrom = new Date(from); //.toLocaleDateString('de', {timeZone: 'UTC'});
  const dateFromString = dateFrom.getFullYear()+"-"+(dateFrom.getMonth().toString().length === 1 ? '0' : '')+(dateFrom.getMonth()+1)+"-"+(dateFrom.getDate().toString().length === 1 ? '0' : '')+dateFrom.getDate();
  const dateUntil = new Date(until); //.toLocaleDateString('de', {timeZone: 'UTC'});
  const dateUntilString = dateUntil.getFullYear()+"-"+(dateUntil.getMonth().toString().length === 1 ? '0' : '')+(dateUntil.getMonth()+1)+"-"+(dateUntil.getDate().toString().length === 1 ? '0' : '')+dateUntil.getDate();

  return `${dateFromString} - ${dateUntilString}`
}

const PricingListItem = (props: any) => {
  const dateFrom = new Date(props.pricing.dateFrom);
  const dateUntil = new Date(props.pricing.dateUntil);
  
  const today = new Date();
  const isCurrentDate = today > dateFrom && today < dateUntil;

  console.log('props.pricing.isNew', props.pricing.isNew);

  return (
    <div className={['partial-pricings__period', props.pricing.isNew ? 'partial-pricings__period--new' : ''].join(' ')} title={props.pricing.id}>
      <Link to={`/pricings-${props.type}/${props.pricing.id}`} className="partial-pricings__period-range">
        {formatPeriod(props.pricing.dateFrom, props.pricing.dateUntil)}
        {isCurrentDate && (<FontAwesomeIcon icon={faCheck} />)}
      </Link>
      <div className="partial-pricings__period-duplicate">
        <button disabled={props.isDisabled} onClick={() => props.handleDuplicate(props.pricing)}>
          <Icon name="duplicate-alt" />
        </button>
      </div>
      <div className="partial-pricings__period-edit">
        <button disabled={props.isDisabled} onClick={() => props.handleEdit(props.pricing)}>
          <Icon name="calendar-black" />
        </button>
      </div>
      <div className="partial-pricings__period-delete">
        <button disabled={props.isDisabled} onClick={() => props.handleDelete(props.pricing)}>
          <Icon name="delete" />
        </button>
      </div>
    </div>
  )
}

export class PricingsPartial extends React.Component<PricingsProps, PricingsState> {
  constructor(props: PricingsProps) {
    super(props);

    this.state = {
        isAddingPeriod: false,
        isEditingPeriod: false,
        isAddingMarket: false,
        isEditingMarket: false,
        isDeletingMarket: false,
        isPausingMarket: false,
        pricings: []
    }
  }

  componentDidUpdate(prevProps: PricingsProps) {
    const prevPricings = prevProps.pricings.result;
    let pricings = this.props.pricings.result;

    const pricingsChanged = pricings && prevPricings !== pricings;
    if (pricingsChanged) {
      if (pricings && prevPricings && prevPricings.length > 0) {
        pricings = pricings.map((pricing) => {
          const doesExist = prevPricings.find((p) => p.id === pricing.id);
          console.log('doesExist', doesExist);
          if (!doesExist) {
            return { ...pricing, isNew: true }; // Mark new items
          }
          return pricing;
        });
      }

      this.setState({
        pricings: pricings
      });

      this.handleDrilledClose();
    }
  }

  public render() {
    const { pricings } = this.state;
    const { selectedPricing } = this.state;

    console.log('pricings', pricings);

    const currentSelectedMarketCountry = selectedPricing && selectedPricing.items.find((i: any) => i.key === 'country');

    return (
      <div className="partial-pricings">
        <PricingsDispatcher />
        <h2 className="mb-5">Time periods and markets</h2>
        <div className="partial-pricings__group">
          <h3 className="mb-4">Accessories</h3>
          <button className="btn btn-secondary partial-pricings__plus" onClick={() => this.handleAdd('accessories')}>
            <Icon name="plus-filled" />
          </button>

          <div className="partial-pricings__periods">
            {pricings && pricings.map((pricing: any) => {
              if (pricing.deleted || pricing.type !== 'accessories') { return; }

              return (
                <PricingListItem key={pricing.id} type="accessories" pricing={pricing} 
                  isDisabled={this.isDisabled} handleEdit={this.handleEdit} handleDelete={this.handleDelete} handleDuplicate={this.handleDuplicate} />
              );
            })}
          </div>
        </div>

        <div className="partial-pricings__group mt-5">
          <h3 className="mb-4">Washbasin</h3>
          <button className="btn btn-secondary partial-pricings__plus" onClick={() => this.handleAdd('washbasin')}>
            <Icon name="plus-filled" />
          </button>

          <div className="partial-pricings__periods">
            {pricings && pricings.map((pricing: any) => {
              if (pricing.deleted || pricing.type !== 'washbasin') { return; }

              return (
                <PricingListItem key={pricing.id} type="washbasin" pricing={pricing} 
                  isDisabled={this.isDisabled} handleEdit={this.handleEdit} handleDelete={this.handleDelete} handleDuplicate={this.handleDuplicate} />
              );
            })}
          </div>
        </div>

        <div className="partial-pricings__group mt-5">
          <h3 className="mb-4">Markets</h3>
          <button className="btn btn-secondary partial-pricings__plus" onClick={() => this.handleAdd('market')}>
            <Icon name="plus-filled" />
          </button>

          <div className="partial-pricings__periods">
            {pricings && pricings.map((pricing: any) => {
              if (pricing.deleted || pricing.type !== 'market') { return; }

              const country = pricing.items.find((i: any) => i.key === 'market' || i.key === 'country');
              const countryCode = country && country.value;
              const countryName = getCountryNameByCode(countryCode);

              const protectedCountries = ['de-DE'];

              return (
                <div className={classNames('partial-pricings__period', {'paused': pricing.paused})}
                  title={pricing.id} key={pricing.id}>
                  <Link to={`/pricings-${pricing.type}/${pricing.id}`} className="partial-pricings__period-range">
                    {countryName}
                  </Link>
                  <div className="partial-pricings__period-delete">
                    {!protectedCountries.includes(countryCode) && (
                      <button disabled={this.isDisabled} onClick={() => {
                        if (pricing.paused) {
                          this.handlePlay(pricing);
                        } else {
                          this.handlePauseMarket(pricing);
                        }
                      }}>
                        <FontAwesomeIcon icon={pricing.paused ? faPlay : faPause} />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        
        {(this.state.isAddingPeriod || this.state.isEditingPeriod) && (
          <PricingsPeriodModal 
            drilledSubmit={this.handleDrilledSubmit} 
            drilledClose={this.handleDrilledClose}
            selectedPricing={selectedPricing}
            isDisabled={this.isDisabled} />
        )}
        
        {(this.state.isDeletingMarket) && (
          <Modal 
            isOpen={this.state.isDeletingMarket} 
            backdrop={true}
            toggle={this.handleDrilledClose}
            className="modal-dialog--medium delete-market-modal"
          >
            <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
              <div>
                <h3 className="modal-heading">Are you sure you want to delete the market {currentSelectedMarketCountry && getCountryNameByCode(currentSelectedMarketCountry.value.toString())}?</h3>
                <div className="modal-body">
                </div>
                <div className="modal-actions text-center d-flex">
                  <button 
                    className="btn btn-light btn-bordered w-100"
                    disabled={this.isDisabled}
                    onClick={this.handleDrilledClose}
                  >
                    Cancel
                  </button>
                  <button 
                    className="btn btn-secondary w-100"
                    disabled={this.isDisabled}
                    onClick={() => this.handleDelete(selectedPricing)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        )}
        
        {(this.state.isPausingMarket) && (
          <Modal 
            isOpen={this.state.isPausingMarket} 
            backdrop={true}
            toggle={this.handleDrilledClose}
            className="modal-dialog--medium pause-market-modal"
          >
            <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
              <div>
                <h3 className="modal-heading">Are you sure you want to pause the market {currentSelectedMarketCountry && getCountryNameByCode(currentSelectedMarketCountry.value.toString())}?</h3>
                <div className="modal-body">
                </div>
                <div className="modal-actions text-center d-flex">
                  <button 
                    className="btn btn-light btn-bordered w-100"
                    disabled={this.isDisabled}
                    onClick={this.handleDrilledClose}
                  >
                    Cancel
                  </button>
                  <button 
                    className="btn btn-secondary w-100"
                    disabled={this.isDisabled}
                    onClick={() => this.handlePause(selectedPricing)}
                  >
                    Pause
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }

  handleAdd = (type: string) => {
    if (type !== 'market') {
      this.setState({
        isAddingPeriod: true,
        addingType: type
      });
    } else {
      this.setState({
        isAddingMarket: true,
        addingType: type
      });
    }
  }

  handleDrilledSubmit = (startDate: Date, endDate: Date) => {
    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      'pricings', {
        url: `/Pricings/replaceOrCreate?returnAll=true`,
        options: {
          method: 'POST',
          data: {
            ...this.state.selectedPricing,
            dateFrom: startDate.toISOString(),
            dateUntil: endDate.toISOString(),
            type: this.state.selectedPricing && this.state.selectedPricing.type || this.state.addingType,
          },
        }
      },
      true
    ));
  }

  handleDrilledClose = () => {
    this.setState({
      isAddingPeriod: false,
      isEditingPeriod: false,
      isAddingMarket: false,
      isEditingMarket: false,
      isDeletingMarket: false,
      isPausingMarket: false,
      addingType: undefined,
      selectedPricing: undefined
    });
  }

  handleEdit = (selectedPricing: any) => {
    this.setState({
      isEditingPeriod: true,
      selectedPricing
    });
  }

  handleEditMarket = (selectedPricing: any) => {
    this.setState({
      isEditingMarket: true,
      selectedPricing
    });
  }

  handlePauseMarket = (selectedPricing: any) => {
    this.setState({
      isPausingMarket: true,
      selectedPricing
    });
  }

  handleDeleteMarket = (selectedPricing: any) => {
    this.setState({
      isDeletingMarket: true,
      selectedPricing
    });
  }

  handleDelete = (pricing?: PricingsModel) => {
    if (!pricing) return

    this.props.dispatch(requestAPIActions.load(
      'pricings', 
      {
        url: `/Pricings/upsertWithWhere?where=${JSON.stringify({id: pricing.id})}&returnAll=true`,
        options: {
          method: 'POST',
          data: { deleted: true }
        }
      },
      true
    ));
  }

  handleDuplicate = (pricing?: PricingsModel) => {
    if (!pricing) return

    const { id, ...pricingClone } = pricing;

    this.props.dispatch(requestAPIActions.load(
      'pricings', 
      {
        url: `/Pricings?returnAll=true`,
        options: {
          method: 'POST',
          data: JSON.parse(JSON.stringify({ ...pricingClone }))
        }
      },
      true
    ));
  }

  handlePause = (pricing?: PricingsModel) => {
    if (!pricing) return

    this.props.dispatch(requestAPIActions.load(
      'pricings', 
      {
        url: `/Pricings/upsertWithWhere?where=${JSON.stringify({id: pricing.id})}&returnAll=true`,
        options: {
          method: 'POST',
          data: { paused: true }
        }
      },
      true
    ));
  }

  handlePlay = (pricing?: PricingsModel) => {
    if (!pricing) return

    this.props.dispatch(requestAPIActions.load(
      'pricings', 
      {
        url: `/Pricings/upsertWithWhere?where=${JSON.stringify({id: pricing.id})}&returnAll=true`,
        options: {
          method: 'POST',
          data: { paused: false }
        }
      },
      true
    ));
  }

  get isDisabled () {
    return this.props.pricings.updating && !this.props.pricings.loaded;
  }
}

export const Pricings = connect((state: GlobalPrivateState) => ({
  pricings: state.pricings,
  params: state.queryState.params,
}))(PricingsPartial);

export default Pricings;
